import React, {useEffect, useState} from 'react';
import {
  Button,
  Divider,
  ListItemText,
  makeStyles,
  MenuItem,
  Radio,
  Select,
  Typography
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CustomSelectField from 'src/modules/admin/modules/ClinicGroups/AddUser/CustomSelectField';
import HelperUtils from '@shared/utils/HelperUtils';
import {useTranslation} from 'react-i18next';
import './CustomDropDownStyles.scss';

const FilterClinicStyles = makeStyles(() => ({
  root: {
    // width: '400px',
    '&:focus': {
      outline: 'none'
    }
  },

  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 16px'
  },
  menu: {
    minWidth: '400px',
    overflow: 'auto',
    '& li': {
      borderBottom: '1px solid #eeeeee'
    },
    '& li:last-child': {
      borderBottom: 'none'
    }
  },
  secondary: {
    '& .MuiListItemText-secondary': {
      fontSize: '0.9rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },

  primary: {
    '& .MuiListItemText-primary': {
      fontSize: '1.2rem',
      overflow: 'hidden',
      width: '100%',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis'
    }
  },

  dropDownWidth: {
    minWidth: '15rem'
  },
  text: {
    fontSize: '1.3rem'
  },
  flex: {
    flex: 1
  },
  clearText: {
    fontSize: '1rem',
    cursor: 'pointer',
    textTransform: 'capitalize'
  },
  error: {
    borderColor: 'red'
  }
}));

interface CustomDropDownProps {
  dropDownList: any;
  placeHolderText: string;
  dropDownHeaderText?: string;
  handleAction(item: any): any;
  format?: string;
  defaultValue?: string;
  forceUpate?: number;
  className?: any;
  clear?: boolean;
  clearAction?: any;
  disabled?: any;
  doNotShowRadioButtons?: boolean;
  error?: boolean;
  opacityProp?: boolean;
}

const CustomDropDown = (props: CustomDropDownProps): React.ReactElement => {
  const classes = FilterClinicStyles();

  const {t} = useTranslation();

  const {
    dropDownList,
    placeHolderText,
    dropDownHeaderText,
    handleAction,
    format,
    defaultValue,
    forceUpate,
    className,
    clear,
    clearAction,
    disabled,
    doNotShowRadioButtons,
    error,
    opacityProp
  } = props;
  // FIXME: Need to use only one useState and check based on Value not based on label... need to change this.
  // const [selectedValue, setSelectedValue] = useState<string | any>('');
  // const [checkValue, setCheckValue] = useState<string | any>('');

  const [selectedValue, setSelectedValue] = useState<string | any>(
    defaultValue ? defaultValue : ''
  );

  useEffect(() => {
    setSelectedValue(defaultValue ? defaultValue : '');
  }, [forceUpate]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleDropDownClick = (item: any) => {
    setSelectedValue(item?.label);
    if (typeof handleAction === 'function') {
      handleAction(item);
    }
  };

  const clearDropDown = () => {
    if (typeof clearAction === 'function') {
      clearAction();
      setSelectedValue('');
    }
  };

  return (
    <div className={[classes.dropDownWidth, classes.flex].join(' ')}>
      <Select
        labelId="demo-multiple-name-label"
        id="demo-multiple-name"
        disabled={disabled}
        data-test-id="pcl-appointments-dateTimeDropdown"
        value={
          selectedValue
            ? format
              ? HelperUtils.formatDisplayDateTime(selectedValue, format)
              : selectedValue
            : placeHolderText
        }
        variant="outlined"
        fullWidth={true}
        style={
          selectedValue ? {} : opacityProp ? {opacity: 0.5} : {opacity: 0.8}
        }
        input={<CustomSelectField />}
        IconComponent={KeyboardArrowDownIcon}
        className={
          disabled
            ? 'select-clinic-disabled'
            : error
            ? 'custom-select-error-styles'
            : 'selectView select-custom-clinic'
        }>
        <div className={classes.root}>
          {dropDownHeaderText && (
            <div className={classes.filterHeader}>
              <div>
                <Typography className={classes.text}>
                  {dropDownHeaderText}
                </Typography>
              </div>
              {!!clear && (
                <Button
                  onClick={() => {
                    clearDropDown();
                  }}
                  className={classes.clearText}>
                  <b>{t('COMMON.CLEAR_ALL')}</b>
                </Button>
              )}
            </div>
          )}
          <Divider />
          <div className={[classes.menu, className].join(' ')}>
            {dropDownList?.map((item: any, index: number) => (
              <MenuItem
                key={item.value}
                value={item.label}
                data-test-id={`pcl-appointments-popOver${index}`}
                onClick={(): void => handleDropDownClick(item)}>
                <ListItemText
                  className={[classes.secondary, classes.primary].join(' ')}
                  primary={
                    format
                      ? HelperUtils.formatDisplayDateTime(item.label, format)
                      : item.label
                  }
                />
                {/* <Radio checked={item?.label === selectedValue ? true : false} /> */}
                {!doNotShowRadioButtons && (
                  <Radio
                    checked={item?.label === selectedValue ? true : false}
                  />
                )}
              </MenuItem>
            ))}
          </div>
        </div>
      </Select>
    </div>
  );
};

export default CustomDropDown;
